export default __webpack_public_path__ + "static/fr-b5be5e099b6ee123da007185bf6248b1.svg";